export const speakers = {
    ru: async () => [
        (await import("./speakers-get-models.ru.js")).default,
        (await import("./speakers-post-models.ru.js")).default,
        (await import("./speakers-get-models-model_id.ru.js")).default,
        (await import("./speakers-delete-models-model_id.ru.js")).default,
        (await import("./speakers-get-tasks.ru.js")).default,
        (await import("./speakers-post-tasks.ru.js")).default,
        (await import("./speakers-get-tasks-task_id.ru.js")).default,
        (await import("./speakers-delete-tasks-task_id.ru.js")).default
    ],
    en: async () => [
        (await import("./speakers-get-models.en.js")).default,
        (await import("./speakers-post-models.en.js")).default,
        (await import("./speakers-get-models-model_id.en.js")).default,
        (await import("./speakers-delete-models-model_id.en.js")).default,
        (await import("./speakers-get-tasks.en.js")).default,
        (await import("./speakers-post-tasks.en.js")).default,
        (await import("./speakers-get-tasks-task_id.en.js")).default,
        (await import("./speakers-delete-tasks-task_id.en.js")).default
    ]
}
